/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type ProductLevel =
  | 'FREE'
  | 'DEPRECATED'
  | 'STARTER'
  | 'BASIC'
  | 'PROFESSIONAL'
  | 'ENTERPRISE'
  | unhandledEnumCase;

export type ProductLine =
  | 'CMS'
  | 'MARKETING'
  | 'OPERATIONS'
  | 'SALES'
  | 'SERVICE'
  | 'COMMERCE'
  | unhandledEnumCase;

export const BadFrontendLocaleTypename =
  'com.hubspot.scopegaps.models.BadFrontendLocale';
export const BadFrontendLocaleDiscriminant = 'BAD_FRONTEND_LOCALE';
export const BadFrontendLocaleDiscriminantKey = 'type';
export type BadFrontendLocale = {
  unrecognizedFrontendLocale: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.scopegaps.models.BadFrontendLocale';
} & { type?: 'BAD_FRONTEND_LOCALE' };

export const BadLocaleLanguageTypename =
  'com.hubspot.scopegaps.models.BadLocaleLanguage';
export const BadLocaleLanguageDiscriminant = 'BAD_LOCALE_LANGUAGE';
export const BadLocaleLanguageDiscriminantKey = 'type';
export type BadLocaleLanguage = {
  unrecognizedLocaleLanguage: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.scopegaps.models.BadLocaleLanguage';
} & { type?: 'BAD_LOCALE_LANGUAGE' };

export const ClientErrorDiscriminantKey = 'type';
export type ClientError =
  | BadLocaleLanguage
  | BadFrontendLocale
  | ConflictingLocales
  | ScopeNotFound
  | ScopeMissingEnum
  | ScopeGroupNotFound
  | MissingPortalContext
  | PortalNotFound
  | SkuAvailabilityError;

export const ConflictingLocalesTypename =
  'com.hubspot.scopegaps.models.ConflictingLocales';
export const ConflictingLocalesDiscriminant = 'CONFLICTING_LOCALES';
export const ConflictingLocalesDiscriminantKey = 'type';
export type ConflictingLocales = {
  frontendLanguageTag: string;
  frontendLocale?: string;
  javaLocaleLanguageTag?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.scopegaps.models.ConflictingLocales';
} & { type?: 'CONFLICTING_LOCALES' };

export const MissingPortalContextTypename =
  'com.hubspot.scopegaps.models.MissingPortalContext';
export const MissingPortalContextDiscriminant = 'MISSING_PORTAL_CONTEXT';
export const MissingPortalContextDiscriminantKey = 'type';
export type MissingPortalContext = {
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.scopegaps.models.MissingPortalContext';
} & { type?: 'MISSING_PORTAL_CONTEXT' };

export const PortalNotFoundTypename =
  'com.hubspot.scopegaps.models.PortalNotFound';
export const PortalNotFoundDiscriminant = 'PORTAL_NOT_FOUND';
export const PortalNotFoundDiscriminantKey = 'type';
export type PortalNotFound = {
  missingPortal: number;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.scopegaps.models.PortalNotFound';
} & { type?: 'PORTAL_NOT_FOUND' };

export const ScopeGroupNotFoundTypename =
  'com.hubspot.scopegaps.models.ScopeGroupNotFound';
export const ScopeGroupNotFoundDiscriminant = 'SCOPE_GROUP_NOT_FOUND';
export const ScopeGroupNotFoundDiscriminantKey = 'type';
export type ScopeGroupNotFound = {
  unrecognized: Default<string[]>;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.scopegaps.models.ScopeGroupNotFound';
} & { type?: 'SCOPE_GROUP_NOT_FOUND' };

export const ScopeMissingEnumTypename =
  'com.hubspot.scopegaps.models.ScopeMissingEnum';
export const ScopeMissingEnumDiscriminant = 'SCOPE_MISSING_ENUM';
export const ScopeMissingEnumDiscriminantKey = 'type';
export type ScopeMissingEnum = {
  missingEnum: Default<string[]>;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.scopegaps.models.ScopeMissingEnum';
} & { type?: 'SCOPE_MISSING_ENUM' };

export const ScopeNotFoundTypename =
  'com.hubspot.scopegaps.models.ScopeNotFound';
export const ScopeNotFoundDiscriminant = 'SCOPE_NOT_FOUND';
export const ScopeNotFoundDiscriminantKey = 'type';
export type ScopeNotFound = {
  unrecognized: Default<string[]>;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.scopegaps.models.ScopeNotFound';
} & { type?: 'SCOPE_NOT_FOUND' };

export const SkuAvailabilityErrorTypename =
  'com.hubspot.scopegaps.models.SkuAvailabilityError';
export const SkuAvailabilityErrorDiscriminant = 'SKU_AVAILABILITY_ERROR';
export const SkuAvailabilityErrorDiscriminantKey = 'type';
export type SkuAvailabilityError = {
  portalIdKey?: number;
  countryKey?: CountryCode;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.scopegaps.models.SkuAvailabilityError';
} & { type?: 'SKU_AVAILABILITY_ERROR' };

export type HierarchyRequest = {
  frontendLocale?: string;
  javaLocaleLanguageTag?: string;
};

export type HierarchyResponse = {
  lines: Default<ProductLine[]>;
  levels: Default<ProductLevel[]>;
  skus: Default<LineLevelSkuResponse[]>;
};

export type LineLevelSkuResponse = {
  sku: SkuProductPiece;
  line: ProductLine;
  level: ProductLevel;
};

export const FreeProductPieceTypename =
  'com.hubspot.scopegaps.models.pieces.FreeProductPiece';
export const FreeProductPieceDiscriminant = 'FREE';
export const FreeProductPieceDiscriminantKey = 'type';
export type FreeProductPiece = {
  __typename: 'com.hubspot.scopegaps.models.pieces.FreeProductPiece';
} & { type?: 'FREE' };

export const ProductPieceDiscriminantKey = 'type';
export type ProductPiece = FreeProductPiece | SkuProductPiece;

export const SkuProductPieceTypename =
  'com.hubspot.scopegaps.models.pieces.SkuProductPiece';
export const SkuProductPieceDiscriminant = 'SKU';
export const SkuProductPieceDiscriminantKey = 'type';
export type SkuProductPiece = {
  sku: string;
  productApiName: string;
  displayName: string;
  versionedName: string;
  __typename: 'com.hubspot.scopegaps.models.pieces.SkuProductPiece';
} & { type?: 'SKU' };

export type ScopesRequest = {
  scopes: Default<string[]>;
  scopeGroups: Default<string[]>;
  minimal: Default<boolean>;
  frontendLocale?: string;
  javaLocaleLanguageTag?: string;
};

export type ScopesRequestBatch = { requests: Default<ScopesRequest[]> };

export type ComboResponse = { and: Default<ProductPiece[]> };

export type CombosResponse = {
  trialing: boolean;
  satisfied: boolean;
  satisfyingCombos: Default<ComboResponse[]>;
  satisfiedWithoutTrials: boolean;
  satisfyingCombosWithoutTrials: Default<ComboResponse[]>;
};

export type CombosResponseBatch = { results: Default<CombosResponse[]> };

export type PublicCombosResponse = {
  satisfyingCombos: Default<ComboResponse[]>;
};

export type PublicCombosResponseBatch = {
  results: Default<PublicCombosResponse[]>;
};

export type OptionResponse = { and: Default<OrResponse[]> };

export type OptionsResponse = {
  trialing: boolean;
  satisfied: boolean;
  satisfyingOptions: Default<OptionResponse[]>;
  satisfiedWithoutTrials: boolean;
  satisfyingOptionsWithoutTrials: Default<OptionResponse[]>;
};

export type OrResponse = { or: Default<ProductPiece[]> };

export type CountryCode =
  | 'UNDEFINED'
  | 'AC'
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'AM'
  | 'AN'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BU'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CP'
  | 'CR'
  | 'CS'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DG'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EA'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'FX'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'IC'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NT'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SF'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SU'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TA'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TP'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UK'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'XK'
  | 'YE'
  | 'YT'
  | 'YU'
  | 'ZA'
  | 'ZM'
  | 'ZR'
  | 'ZW'
  | unhandledEnumCase;

export type GetProductHierarchyRequestType = Requestify<HierarchyRequest>;
export type GetProductHierarchyResponseType = HierarchyResponse;
export type GetProductHierarchyErrorType = ClientError & HubspotMetadata;
export const getProductHierarchyRpc: ChirpAvroRpcDetails<
  GetProductHierarchyRequestType,
  GetProductHierarchyResponseType,
  GetProductHierarchyErrorType,
  false
> = {
  serviceName: 'com.hubspot.scopegaps.rpc.ScopeGapsService',
  rpcName: 'getProductHierarchy',
  auth: 'app',
  fingerprint: 'KFJyfm2wv1_a3HNHDiQX0IeSZtm_cDAD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSatisfyingOptionsRequestType = Requestify<ScopesRequest>;
export type GetSatisfyingOptionsResponseType = OptionsResponse;
export type GetSatisfyingOptionsErrorType = ClientError & HubspotMetadata;
export const getSatisfyingOptionsRpc: ChirpAvroRpcDetails<
  GetSatisfyingOptionsRequestType,
  GetSatisfyingOptionsResponseType,
  GetSatisfyingOptionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.scopegaps.rpc.ScopeGapsService',
  rpcName: 'getSatisfyingOptions',
  auth: 'app',
  fingerprint: 'aAvUtM_cLA2l4uY41cZtpoeSZtm_cDAD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSatisfyingCombosRequestType = Requestify<ScopesRequest>;
export type GetSatisfyingCombosResponseType = CombosResponse;
export type GetSatisfyingCombosErrorType = ClientError & HubspotMetadata;
export const getSatisfyingCombosRpc: ChirpAvroRpcDetails<
  GetSatisfyingCombosRequestType,
  GetSatisfyingCombosResponseType,
  GetSatisfyingCombosErrorType,
  false
> = {
  serviceName: 'com.hubspot.scopegaps.rpc.ScopeGapsService',
  rpcName: 'getSatisfyingCombos',
  auth: 'app',
  fingerprint: 'aAvUtM_cLA3BkG6MxGG6wYeSZtm_cDAD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSatisfyingCombosBatchRequestType =
  Requestify<ScopesRequestBatch>;
export type GetSatisfyingCombosBatchResponseType = CombosResponseBatch;
export type GetSatisfyingCombosBatchErrorType = ClientError & HubspotMetadata;
export const getSatisfyingCombosBatchRpc: ChirpAvroRpcDetails<
  GetSatisfyingCombosBatchRequestType,
  GetSatisfyingCombosBatchResponseType,
  GetSatisfyingCombosBatchErrorType,
  false
> = {
  serviceName: 'com.hubspot.scopegaps.rpc.ScopeGapsService',
  rpcName: 'getSatisfyingCombosBatch',
  auth: 'app',
  fingerprint: 'kqr3ieWObxRrhIN66gl824eSZtm_cDAD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetFullSatisfyingCombosRequestType = Requestify<ScopesRequest>;
export type GetFullSatisfyingCombosResponseType = PublicCombosResponse;
export type GetFullSatisfyingCombosErrorType = ClientError & HubspotMetadata;
export const getFullSatisfyingCombosRpc: ChirpAvroRpcDetails<
  GetFullSatisfyingCombosRequestType,
  GetFullSatisfyingCombosResponseType,
  GetFullSatisfyingCombosErrorType,
  false
> = {
  serviceName: 'com.hubspot.scopegaps.rpc.ScopeGapsService',
  rpcName: 'getFullSatisfyingCombos',
  auth: 'app',
  fingerprint: 'aAvUtM_cLA21UP0wptIHx4eSZtm_cDAD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetFullSatisfyingCombosBatchRequestType =
  Requestify<ScopesRequestBatch>;
export type GetFullSatisfyingCombosBatchResponseType =
  PublicCombosResponseBatch;
export type GetFullSatisfyingCombosBatchErrorType = ClientError &
  HubspotMetadata;
export const getFullSatisfyingCombosBatchRpc: ChirpAvroRpcDetails<
  GetFullSatisfyingCombosBatchRequestType,
  GetFullSatisfyingCombosBatchResponseType,
  GetFullSatisfyingCombosBatchErrorType,
  false
> = {
  serviceName: 'com.hubspot.scopegaps.rpc.ScopeGapsService',
  rpcName: 'getFullSatisfyingCombosBatch',
  auth: 'app',
  fingerprint: 'kqr3ieWObxQ3ilaxk7zOPoeSZtm_cDAD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
